module.exports = __webpack_public_path__ + "img/info.a754c1ce.svg";